module.exports = __webpack_public_path__ + "img/ranking_blue.5e505916.png";